const overflowSliderSections = document.querySelectorAll( ".overflow-slider" );

overflowSliderSections.forEach( ( section ) => {
  const sliderDiv = section.querySelector( ".slider" );
  const slides = section.querySelectorAll( ".slider > div" );
  const controlsContainer = section.querySelector( ".slider-controls" );
  const progressBar = section.querySelector( ".progress-bar > .progress" );

  if ( sliderDiv && slides.length > 0 ) {
    const overflowSlider = tns( {
      container: sliderDiv,
      autoplay: false,
      controls: true,
      nav: false,
      loop: false,
      autoplayButtonOutput: false,
      controlsContainer: controlsContainer || null,
      speed: 500,
      gutter: 12,
      fixedWidth: 282,
      responsive: {
        768: {
          fixedWidth: 282,
          gutter: 24,
          items: 2,
        },
      },
    } );

    const prevBtn = controlsContainer.querySelector( "button:first-child" );
    const nextBtn = controlsContainer.querySelector( "button:last-child" );

    // ---- CONTROL BUTTON STATE LOGIC ----
    const updateControls = () => {
      const info = overflowSlider.getInfo();
      const index = info.index; // 0-based index
      const visible = info.items;
      const maxIndex = info.slideCount - visible;

      // Disable prev at start
      if ( index <= 0 ) {
        prevBtn.disabled = true;
      } else {
        prevBtn.disabled = false;
      }

      // Disable next at the end
      if ( index >= maxIndex ) {
        nextBtn.disabled = true;
      } else {
        nextBtn.disabled = false;
      }
    };

    // Initial state
    updateControls();

    overflowSlider.events.on( "indexChanged", updateControls );

    // ---- PROGRESS BAR ----
    if ( progressBar ) {
      const totalSlides = slides.length;

      const updateProgressBar = () => {
        const info = overflowSlider.getInfo();
        const currentIndex = info.index + 1;
        const visibleItems = info.items;
        const maxIndex = info.slideCount + 1 - visibleItems;
        const percent = Math.min( ( currentIndex / maxIndex ) * 100, 100 );
        progressBar.style.width = `${ percent }%`;
      };

      updateProgressBar();
      overflowSlider.events.on( "indexChanged", updateProgressBar );
    }
  }
  // ---- EQUAL HEIGHTS FOR SLIDES ----
  function setEqualHeights ( selector ) {
    const cards = document.querySelectorAll( selector );
    let maxHeight = 0;

    cards.forEach( card => {
      card.style.height = 'auto'; // reset height
      if ( card.offsetHeight > maxHeight ) maxHeight = card.offsetHeight;
    } );

    cards.forEach( card => card.style.height = maxHeight + 'px' );
  }

  // Run on load and resize
  window.addEventListener( 'load', () => setEqualHeights( '.slider .flex-1 > div' ) );
  window.addEventListener( 'resize', () => setEqualHeights( '.slider .flex-1 > div' ) );

} );
